import { createAction, props } from '@ngrx/store';
import { Tenant } from '../../models/tenant/tenant.model';

export const loadTenants = createAction('[Tenants Facade] Load Tenants');

export const loadTenantsSuccess = createAction('[Tenants Effect] Load Tenants Success', props<{ tenants: Array<Tenant> }>());
